{
  // 目次の位置を最初のh2の直前に置くように指定
  const affiliateCode =
    ' <div class="toc-container" id="toc_container"><button class="toc-title">目次</button><div id="toc" class="toc-contents"></div></div>';
  const tocTarget = document.querySelector("#toc_target");
  const firstH2 = tocTarget.querySelector("h2");
    if (firstH2) {
      firstH2.insertAdjacentHTML("beforebegin", affiliateCode);
    }
  
  // 目次の読み込み
  const TOC_INSERT_SELECTOR = "#toc";
  const HEADING_SELECTOR = "h2,h3,h4,h5,h6";
  const LINK_CLASS_NAME = "tocLink";
  const ID_NAME = "heading";
  const tocInsertElement = document.querySelector(TOC_INSERT_SELECTOR);
  const headingElements = tocTarget.querySelectorAll(HEADING_SELECTOR);
  const layer = [];
  let id = 0;
  const uid = () => `${ID_NAME}${id++}`;
  let oldRank = -1;
  try {
    const createLink = (el) => {
      let li = document.createElement("li");
      let a = document.createElement("a");
      el.id = el.id || uid();
      a.href = `#${el.id}`;
      a.innerText = el.innerText;
      a.className = LINK_CLASS_NAME;
      li.appendChild(a);
      return li;
    };
    const findParentElement = (layer, rank, diff) => {
      do {
        rank += diff;
        if (layer[rank]) return layer[rank];
      } while (0 < rank && rank < 7);
      return false;
    };
    const appendToc = (el, toc) => {
      el.appendChild(toc.cloneNode(true));
    };
    headingElements.forEach((el) => {
      let rank = Number(el.tagName.substring(1));
      let parent = findParentElement(layer, rank, -1);
      if (oldRank > rank) layer.length = rank + 1;
      if (!layer[rank]) {
        layer[rank] = document.createElement("ol");
        if (parent.lastChild) parent.lastChild.appendChild(layer[rank]);
      }
      layer[rank].appendChild(createLink(el));
      oldRank = rank;
    });
    if (layer.length)
      appendToc(tocInsertElement, findParentElement(layer, 0, 1));
  } catch (e) {
    //error
  }

  //クリック時のスクロール後の位置を調整
  const links = document.querySelectorAll(`.${LINK_CLASS_NAME}`);
  links.forEach((el) => {
    el.addEventListener("click", (e) => {
      const targetEl = document.querySelector(el.hash);
      if (window.matchMedia("(max-width: 640px)").matches) {
        //スマホ処理
        scrollTo(
          0,
          window.pageYOffset + targetEl.getBoundingClientRect().top - 110
        );
      } else if (window.matchMedia("(min-width:641px)").matches) {
        //PC処理
        scrollTo(
          0,
          window.pageYOffset + targetEl.getBoundingClientRect().top - 210
        );
      }

      e.preventDefault();
      e.stopPropagation();
    });
  });
}

// 目次のメニューを開く関数
const menu = document.querySelectorAll(".toc-title");

function toggle() {
  const content = this.nextElementSibling;
  this.classList.toggle("toc-active");
  content.classList.toggle("toc-close");
}

for (let i = 0; i < menu.length; i++) {
  menu[i].addEventListener("click", toggle);
}
